import React from 'react';

interface WelcomeBannerProps {
  showStarterMessages: boolean;
}

const WelcomeBanner: React.FC<WelcomeBannerProps> = ({ showStarterMessages }) => {
  if (!showStarterMessages) return null;

  return (
    <div className="welcome-banner">
      <div className="welcome-robot">
        
      </div>
      <p style={{ fontSize: "36px", fontWeight: 'bolder'}}>Hi!</p>
    </div>
  );
};

export default WelcomeBanner;
